import backgroundImage from '../assets/bg-hexagon.svg';
import logo from '../assets/ic_logo.svg';
import logoWhite from '../assets/ic_logo_white.svg';
import dataDrivenImage from '../assets/globe_static.svg';
import solutionsIcon from '../assets/ic_solutions.svg';
import scrollImage from '../assets/parallaximage.jpg';
// import {Button, Col, Container, Image, Row, Stack} from "react-bootstrap";
import "./style.scss"
import {Player} from '@lottiefiles/react-lottie-player';
import animationData from "../lotties/Windmill.json"
import dataDriven from "../lotties/dataDriven.json"
import ace1 from "../lotties/ace1.json"
import ace2 from "../lotties/ace2.json"
import ace3 from "../lotties/ace3.json"
import {useEffect, useRef, useState} from "react";
import {throttle} from "lodash";
import FormPopUp from "./FormPopUp";

import textBalancer from 'text-balancer';

// import animationData from "../lotties/abc.json"


function App() {
    const divStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // width: '100vw',
        // minHeight: '100vh',
        // width: '100vw',
        overflowX: 'clip',
        display: 'flex',
        justifyContent: 'center'

        //     display: flex;
        //     justify-content: center;
        //     align-items: center;
        // justifyContent: '-webkit-center'
    };

    const [modalShow, setModalShow] = useState(false);

    const child1 = useRef(0);
    const child2 = useRef(0);
    const child3 = useRef(0);

    textBalancer.balanceText();

    const handleMouseEnter = (ref) => {
        if (ref.current) {
            ref.current.setSeeker(0, true)
            ref.current.play();
        }

    };

    const handleMouseLeave = (ref) => {
        if (ref.current) {
            ref.current.stop();
            ref.current.setSeeker(100, false)
        }
    };


    let [scrollValue, setScrollLValue] = useState('0%')

    const handleScroll = throttle(() => {
        const position = window.pageYOffset;
        const clampedValue = Math.min(Math.max(position, 10), 1000);
        const mappedValue = ((clampedValue / 1000) * 100).toFixed(2); // Rounding to two decimal places

        // Only update the state if the value has changed
        if (scrollValue !== `${mappedValue}%`) {
            setScrollLValue(`${mappedValue}%`);
        }
    }, 100); // A`

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: true});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);


    // useEffect(()=>{
    //     if (child1.current !== 0) {
    //         // child1.current.seek(10); // Replace 10 with the frame number you want to freeze
    //         child1.current.stop();
    //         child1.current.setSeeker(100, false)// Pause the animation at the specified frame
    //         // alert("1")
    //     }
    //     if (child2.current !== 0) {
    //         // child1.current.seek(10); // Replace 10 with the frame number you want to freeze
    //         child2.current.stop();
    //         child2.current.setSeeker(100, false)// Pause the animation at the specified frame
    //         // alert("2")
    //     }
    //     if (child3.current !== 0) {
    //         // child1.current.seek(10); // Replace 10 with the frame number you want to freeze
    //         child3.current.stop();
    //         child3.current.setSeeker(100, false)// Pause the animation at the specified frame
    //         // alert("3")
    //     }
    // },[]);

    useEffect(() => {
        const parallaxElements = document.querySelectorAll('.parallax');

        const handleScroll = () => {
            window.requestAnimationFrame(() => {
                const scrolled = window.scrollY;

                parallaxElements.forEach((element) => {
                    element.style.transform = `translate3d( ${scrolled * -0.3}px, 0, 0 )`;
                    // currentElement.style.objectPosition = `${scrolled}%, 0)`;
                });
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (

        <div style={divStyle}>
            <div className="rootrootroot">
                {/*<div className="logoContainer">*/}
                {/*    <img src={logo} className="atsuya-logo" alt={"logo-icon"}></img>*/}
                {/*</div>*/}
                <div className="secondContainer">
                    <div className="getEsgReady">
                        <div className="textEsgReady">Get ESG-ready,
                        </div>
                        <div className="textEsgReady">the AOne way!</div>

                        <div className="esgReadyContent">
                            Sustainability strategy and <br/>
                            reporting made simple, easy and <br/>
                            meaningful like never before.
                        </div>

                        <div className="threePointers">
                            <div className="eachPointer pointer1">Unified <br/>Platform</div>
                            <div className="eachPointer pointer2">Personalised <br/>Consulting</div>
                            <div className="eachPointer pointer3">Automated <br/>Report Generation</div>
                        </div>

                        <div>
                            <div className="eachPointer pointer3-xs">Automated <br/>Report Generation</div>
                        </div>

                        <div className="ctaOne" onClick={() => setModalShow(true)}>
                            <div className="arrowHolder">
                                <div className="icon arrow"></div>
                            </div>
                            <div>
                                <div className="startNowParent">
                                    <div className="startNow">START NOW,</div>
                                    <div className="tooLate">BEFORE IT'S TOO LATE</div>
                                </div>
                            </div>
                        </div>
                        <div className="startNowStroke"></div>
                    </div>


                    <div className="getEsgReadyImage">
                        <div className="image">
                            <img
                                // style={{objectPosition: scrollValue}}
                                // className="scrollImage"
                                className="parallax"
                                src={scrollImage} alt="scroll image"/>
                        </div>
                        <div className="windMillHolder">
                            <Player
                                autoplay
                                loop
                                src={animationData}
                                className="windmill"
                            />

                            <Player
                                autoplay
                                loop
                                src={animationData}
                                className="windmill2"
                            />

                            <img className="solutionsIcon" src={solutionsIcon}/>

                        </div>
                    </div>
                </div>
                <div className="thirdContainer">
                    <div className="dataDrivenAsset">
                        {/*<Player*/}
                        {/*    autoplay*/}
                        {/*    loop*/}
                        {/*    src={dataDriven}*/}
                        {/*    className="lottie-animation"*/}
                        {/*>*/}

                        {/*</Player>*/}
                        <img className="overlay-image" src={dataDrivenImage}/>
                        {/*<img className="lottie-animation" src={dataDrivenImage}/>*/}


                    </div>
                    <div className="dataDriven">

                        <div className="textEsgExcellence">The data-driven route
                        </div>
                        <div className="textEsgExcellence">to ESG excellence</div>

                        <div className="esgExcellenceContent balance-text ">
                            For a business, becoming ESG compliant could mean gathering data from every nook of your
                            operations, choosing the right formats and frameworks that suit your industry, and
                            generating reports to file in time for the deadline. Sounds overwhelming? We have a
                            solution!
                        </div>
                    </div>
                </div>
                <div className="fourthContainer">
                    <div className="aceEsg">
                        Ace your ESG Game<br/>
                        with Atsuya’s AOne
                    </div>

                    <div className="aceEsgContent balance-text ">
                        At Atsuya, we don’t see sustainability in business operations as a once-in-a-year activity. We
                        believe in sustainability by the minute. That’s why we offer comprehensive end-to-end solutions,
                        encompassing strategic planning, technology integration, and reporting, to seamlessly
                        incorporate sustainability into your business plan.
                    </div>
                </div>

                <div className="fifthContainer">
                    <div className="aceCard"
                         onMouseEnter={() => handleMouseEnter(child1)}
                         onMouseLeave={() => handleMouseLeave(child1)}>
                        <Player
                            autoplay
                            loop
                            src={ace1}
                            ref={child1}
                            onEvent={event => {
                                console.log(event)
                                if (event === 'load') {
                                    child1.current.setSeeker(100, false)
                                }
                            }}
                            className="ace_lottie"
                        />

                        <div className="aceTitle">Strategise with Expert Guidance</div>
                        <div className="aceContent balance-text ">Our team of experts collaborates closely with your
                            leadership team
                            to develop a strategic plan, enabling technology integration and selecting reporting formats
                            tailored to your business's unique needs.
                        </div>
                    </div>

                    <div className="aceCard"
                         onMouseEnter={() => handleMouseEnter(child2)}
                         onMouseLeave={() => handleMouseLeave(child2)}>
                        <Player
                            ref={child2}
                            autoplay
                            loop
                            onEvent={event => {
                                console.log(event)
                                if (event === 'load') {
                                    child2.current.setSeeker(100, false)
                                }
                            }}
                            src={ace2}
                            className="ace_lottie"
                        />

                        <div className="aceTitle">A Single Destination for All Your Business Data</div>
                        <div className="aceContent balance-text ">Effortlessly monitor and manage your business's
                            performance with
                            the
                            unified AOne platform. It simplifies data collection in line with international
                            reporting
                            standards and formats such as BRSR, GRI, ESRS, SASB, and GRESB.
                        </div>
                    </div>

                    <div className="aceCard"
                         onMouseEnter={() => handleMouseEnter(child3)}
                         onMouseLeave={() => handleMouseLeave(child3)}>
                        <Player
                            ref={child3}
                            src={ace3}
                            loop
                            onEvent={event => {
                                console.log(event)
                                if (event === 'load') {
                                    child3.current.setSeeker(100, false)
                                }
                            }}
                            className="ace_lottie"
                        />


                        <div className="aceTitle">Automated Report Generation</div>
                        <div className="aceContent balance-text ">A structured data collection system for efficient
                            report generation
                            at the click of a button. Ensure timely and accurate reports without the need for extensive
                            manual labour, thereby enhancing operational efficiency and reducing the risk of human
                            errors.
                        </div>
                    </div>
                </div>


                <div className="seventhContainer">
                    <div className="sustainabilityTitle">Join the Sustainability Revolution</div>
                    <div className="sustainabilityContent balance-text" onClick={() => {
                        setModalShow(true);
                    }
                    }>
                        At Atsuya, we believe that sustainability is the key to unlocking great value for your
                        profits and the planet. Let us be your partner on this transformative journey towards a more
                        sustainable tomorrow.
                        <div className="flexboy">
                            <div className="ctaTwo" >SCHEDULE A MEETING
                            </div>
                        </div>
                    </div>
                </div>


                {/*<div className="eighthContainer">*/}
                {/*    <footer id="colophon" className="site-footer">*/}
                {/*        <div className="container common-container-xl">*/}

                {/*            <div className="site-info">*/}
                {/*                <div className="row">*/}
                {/*                    <div className="col-lg-10 col-md-9">*/}
                {/*                        <div className="row">*/}
                {/*                            <ul className="col-xl-4 col-lg-6">*/}
                {/*                                <li>SOLUTIONS</li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/refrigeration-monitoring/">Refrigeration*/}
                {/*                                        Monitoring</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/water-monitoring/">Water*/}
                {/*                                        Monitoring</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/energy-monitoring/">Energy*/}
                {/*                                        Monitoring</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/gas-monitoring-leak-detection/">Gas*/}
                {/*                                        Monitoring &amp; Leak Detection</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/hvac/">HVAC</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/sustainability-consulting/">Sustainability*/}
                {/*                                        Consulting</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/supply-chains/">Supply Chains</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/integrated-compliance-ticketing/">Integrated*/}
                {/*                                        Compliance &amp; Ticketing</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/video-analytics/">Video*/}
                {/*                                        Analytics</a>*/}
                {/*                                </li>*/}
                {/*                            </ul>*/}
                {/*                            <ul className="col-xl-3 col-lg-6">*/}
                {/*                                <li>INDUSTRIES</li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/real-estate/">Real Estate</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/shipping-logistics/">Shipping &amp; Logistics</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/retail-quick-commerce/">Retail &amp; Quick*/}
                {/*                                        Commerce</a>*/}
                {/*                                </li>*/}
                {/*                                <li>*/}
                {/*                                    <a href="https://atsuyatech.com/horeca/">HoReCa</a>*/}
                {/*                                </li>*/}
                {/*                            </ul>*/}
                {/*                            <ul className="col-xl-3 col-lg-6">*/}
                {/*                                <li>RESOURCES</li>*/}

                {/*                                <li><a href="https://atsuyatech.com/blogs/">Blogs</a></li>*/}
                {/*                                <li><a href="https://atsuyatech.com/casestudies/">Case Studies</a></li>*/}


                {/*                            </ul>*/}
                {/*                            <ul className="col-xl-2 col-lg-6">*/}
                {/*                                <li>COMPANY</li>*/}

                {/*                                <li><a href="https://atsuyatech.com/about-us">About Us</a></li>*/}
                {/*                                <li><a*/}
                {/*                                    href="https://atsuyatech.com/about-us/?rel=leadership">Leadership</a>*/}
                {/*                                </li>*/}


                {/*                            </ul>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    <div className="col-lg-2 col-md-3  pad0">*/}

                {/*                    <div className="site-name">*/}
                {/*                        <div className="site-logo"><img*/}
                {/*                            className="whiteLogo"*/}
                {/*                            src={logoWhite}*/}
                {/*                            alt="Atsuya"/></div>*/}
                {/*                    </div>*/}

                {/*                        <aside className="widget-area">*/}
                {/*                            <section id="block-6" className="widget widget_block">*/}
                {/*                                <div*/}
                {/*                                    className="wp-block-group is-layout-flow wp-block-group-is-layout-flow">*/}
                {/*                                    <div className="wp-block-group__inner-container">*/}
                {/*                                        <h2 className="wp-block-heading">Let's Connect</h2>*/}
                {/*                                    </div>*/}
                {/*                                </div>*/}
                {/*                            </section>*/}
                {/*                            <section id="block-7" className="widget widget_block justifyer">*/}
                {/*                                <ul className="wp-block-social-links is-layout-flex wp-block-social-links-is-layout-flex makeFlex fixSocial">*/}
                {/*                                    <li className="wp-social-link wp-social-link-linkedin  wp-block-social-link">*/}
                {/*                                        <a rel=" noopener nofollow" target="_blank"*/}
                {/*                                           href="https://www.linkedin.com/company/atsuyatechnologies/%20%20%20target=_blank"*/}
                {/*                                           className="wp-block-social-link-anchor">*/}
                {/*                                            <svg width="48" height="48" viewBox="0 0 24 24"*/}
                {/*                                                 version="1.1"*/}
                {/*                                                 xmlns="http://www.w3.org/2000/svg" aria-hidden="true"*/}
                {/*                                                 focusable="false"*/}
                {/*                                                 className="socialIcons">*/}
                {/*                                                <path*/}
                {/*                                                    d="M19.7,3H4.3C3.582,3,3,3.582,3,4.3v15.4C3,20.418,3.582,21,4.3,21h15.4c0.718,0,1.3-0.582,1.3-1.3V4.3 C21,3.582,20.418,3,19.7,3z M8.339,18.338H5.667v-8.59h2.672V18.338z M7.004,8.574c-0.857,0-1.549-0.694-1.549-1.548 c0-0.855,0.691-1.548,1.549-1.548c0.854,0,1.547,0.694,1.547,1.548C8.551,7.881,7.858,8.574,7.004,8.574z M18.339,18.338h-2.669 v-4.177c0-0.996-0.017-2.278-1.387-2.278c-1.389,0-1.601,1.086-1.601,2.206v4.249h-2.667v-8.59h2.559v1.174h0.037 c0.356-0.675,1.227-1.387,2.526-1.387c2.703,0,3.203,1.779,3.203,4.092V18.338z"*/}
                {/*                                                    fill="white"*/}
                {/*                                                ></path>*/}
                {/*                                            </svg>*/}
                {/*                                            /!*<span*!/*/}
                {/*                                            /!*    className="wp-block-social-link-label screen-reader-text">LinkedIn</span>*!/*/}
                {/*                                        </a>*/}
                {/*                                    </li>*/}

                {/*                                    <li className="wp-social-link wp-social-link-twitter  wp-block-social-link">*/}
                {/*                                        <a rel=" noopener nofollow" target="_blank"*/}
                {/*                                           href="https://twitter.com/AtsuyaTech"*/}
                {/*                                           className="wp-block-social-link-anchor">*/}
                {/*                                            <svg width="48" height="48"*/}
                {/*                                                 viewBox="0 0 24 24"*/}
                {/*                                                 version="1.1"*/}
                {/*                                                 xmlns="http://www.w3.org/2000/svg" aria-hidden="true"*/}
                {/*                                                 focusable="false"*/}
                {/*                                                 className="socialIcons">*/}
                {/*                                                <path*/}
                {/*                                                    d="M22.23,5.924c-0.736,0.326-1.527,0.547-2.357,0.646c0.847-0.508,1.498-1.312,1.804-2.27 c-0.793,0.47-1.671,0.812-2.606,0.996C18.324,4.498,17.257,4,16.077,4c-2.266,0-4.103,1.837-4.103,4.103 c0,0.322,0.036,0.635,0.106,0.935C8.67,8.867,5.647,7.234,3.623,4.751C3.27,5.357,3.067,6.062,3.067,6.814 c0,1.424,0.724,2.679,1.825,3.415c-0.673-0.021-1.305-0.206-1.859-0.513c0,0.017,0,0.034,0,0.052c0,1.988,1.414,3.647,3.292,4.023 c-0.344,0.094-0.707,0.144-1.081,0.144c-0.264,0-0.521-0.026-0.772-0.074c0.522,1.63,2.038,2.816,3.833,2.85 c-1.404,1.1-3.174,1.756-5.096,1.756c-0.331,0-0.658-0.019-0.979-0.057c1.816,1.164,3.973,1.843,6.29,1.843 c7.547,0,11.675-6.252,11.675-11.675c0-0.178-0.004-0.355-0.012-0.531C20.985,7.47,21.68,6.747,22.23,5.924z"*/}
                {/*                                                    fill="white"*/}
                {/*                                                ></path>*/}
                {/*                                            </svg>*/}
                {/*                                            /!*<span*!/*/}
                {/*                                            /!*    className="wp-block-social-link-label screen-reader-text">Twitter</span>*!/*/}
                {/*                                        </a>*/}
                {/*                                    </li>*/}

                {/*                                    <li className="wp-social-link wp-social-link-facebook  wp-block-social-link">*/}
                {/*                                        <a rel=" noopener nofollow" target="_blank"*/}
                {/*                                           href="https://www.facebook.com/profile.php?id=100076282984527"*/}
                {/*                                           className="wp-block-social-link-anchor">*/}
                {/*                                            <svg width="48" height="48"*/}
                {/*                                                 viewBox="0 0 24 24"*/}
                {/*                                                 version="1.1"*/}
                {/*                                                 xmlns="http://www.w3.org/2000/svg" aria-hidden="true"*/}
                {/*                                                 focusable="false"*/}
                {/*                                                 className="socialIcons">*/}
                {/*                                                <path*/}
                {/*                                                    d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"*/}
                {/*                                                    fill="white"*/}
                {/*                                                ></path>*/}
                {/*                                            </svg>*/}
                {/*                                            /!*<span*!/*/}
                {/*                                            /!*    className="wp-block-social-link-label screen-reader-text">Facebook</span>*!/*/}
                {/*                                        </a>*/}
                {/*                                    </li>*/}
                {/*                                </ul>*/}
                {/*                            </section>*/}
                {/*                        </aside>*/}

                {/*                    </div>*/}

                {/*                </div>*/}


                {/*                <div className="powered-by row">*/}
                {/*                    <div className="col-12 pad0 mtop1 copyright">*/}
                {/*                        <p>© 2022-23 Atsuya Technologies. All Rights Reserved.</p>*/}
                {/*                    </div>*/}
                {/*                </div>*/}

                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </footer>*/}
                {/*</div>*/}


            </div>

            <FormPopUp show={modalShow} onHide={() => setModalShow(false)}/>

        </div>
    )
}

function preventWidow(text) {
    const words = text.split(' ');
    if (words.length > 1) {
        words[words.length - 2] += '\u00A0'; // Unicode non-breaking space
    }
    return words.join(' ');
}

export default App;

